/**
 * @see https://www.npmjs.com/package/react-rating-stars-component
 */

import React from 'react'

import ReactStars from 'react-rating-stars-component'

import PropTypes from 'prop-types'

import { useField } from '@unform/core'

import { Container } from './styles'

const Rating = ({ name, disabled, ...props }) => {
  const { fieldName, defaultValue = 0, error, registerField } = useField(name)

  const inputRef = React.useRef(null)

  const handleChange = React.useCallback(
    (rating) => {
      /*
       * If you use a setState it triggers unwanted DOM updates wich makes
       * the input unmutable due to the defaultValue been set every time
       */
      inputRef.current.dataset.rating = rating
    },
    []
  )

  React.useEffect(() => {
    registerField({
      ref: inputRef.current,
      name: fieldName,
      path: 'value',
      getValue (input) {
        return input?.dataset?.rating
      }
    })
  }, [registerField, fieldName, inputRef])

  return (
    <Container ref={inputRef} data-rating={defaultValue} disabled={disabled}>
      <ReactStars
        {...props}
        key={defaultValue}
        value={Number(defaultValue)}
        onChange={handleChange}
      />
      {error && (
        <span className="rating__error">
          <small>{error}</small>
        </span>
      )}
    </Container>
  )
}

Rating.defaultProps = {
  count: 5,
  size: 24,
  disabled: false,
  activeColor: '#ffc400'
}

Rating.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool
}

export default Rating
